const BlazeError = require('./errors/blaze');
const BlazeAuthenticationError = require('./errors/authentication');
const BlazeValidationError = require('./errors/validation');
const BlazePermissionError = require('./errors/permission');
const printError = require('./utils/helpers/print');

module.exports = {
  BlazeError,
  BlazeAuthenticationError,
  BlazeValidationError,
  BlazePermissionError,
  printError
};
